<template>
    <CRow>
        <CCol col="12" xl="8">
            <CCard>
                <CCardHeader>
                    <strong>СМС Сервис</strong>
                </CCardHeader>
                <CForm>
                    <CCardBody>
                        <SMSServiceTabLinks />
                        <CRow class="pl-3 pb-3" />
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Номер телефона
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="phone" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label"> Текст </CCol>
                            <CCol sm="9">
                                <CInput v-model="text" />
                            </CCol>
                        </CRow>
                    </CCardBody>
                    <CCardFooter>
                        <CButton
                            color="primary"
                            class="mr-3"
                            @click="check"
                        >Проверить</CButton
                        >
                    </CCardFooter>
                </CForm>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import SMSServiceTabLinks from '@/components/SMSServiceTabLinks';

    export default {
        name: 'SMSServiceTest',

        components: {
            SMSServiceTabLinks,
        },

        data() {
            return {
                phone: '+7',
                text: 'Код проверки ' + this.between(1000, 10000),
            };
        },

        methods: {
            validatePhone(phone) {
                if (phone.charAt(0) !== '+' || phone.charAt(1) !== '7') {
                    this.$root.$emit('showError', 'Номер телефона должен начинаться с "+7".');
                    return false;
                }
                if (phone.length !== 12) {
                    this.$root.$emit('showError', 'Номер телефона должен состоять из 11 цифр.');
                    return false;
                }
                for (var i = 2; i < phone.length; i++) {
                    if (
                        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].indexOf(
                            phone.charAt(i)
                        ) === -1
                    ) {
                        this.$root.$emit('showError', 'Номер телефона должен содержать только цифры.');
                        return false;
                    }
                }
                return true;
            },

            validateText(text) {
                return text !== null && text !== '';
            },

            check() {
                if (!this.validatePhone(this.phone)) {
                    return;
                }
                if (!this.validateText(this.text)) {
                    this.$root.$emit('showError', 'Введите текст.');
                    return;
                }
                Vue.axios
                    .post('/services/sms/test', {
                        phone: this.phone,
                        text: this.text,
                    })
                    .then(resp => {
                        this.$root.$emit('showAlert', 'Сообщение отправлено.');
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка при отправке тестового сообщения. ' + err);
                    });
            },

            between(min, max) {
                return Math.floor(Math.random() * (max - min) + min);
            },
        },
    };
</script>
